import { PageConstant } from './../../../constant/page.constant';
import { SpriteConstant } from './../../../constant/sprite.constant';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MenuListConstant } from '../../../constant/menu.list.constant';
import { FirebaseAnalyticsService } from '../../../services/firebaseanalytics.service';
import { FirebaseConstant } from '../../../constant/firebase.constant';

@Component({
    templateUrl: '../../../template/noop.template.html',
    standalone: false
})
export class SelectSymbolsLayoutComponent implements OnInit {
  @Output() eventEmit: EventEmitter<string> = new EventEmitter<string>();
  menu_icons: any;
  symbolsArr = [];

  version = '';

  constructor(public firebaseAnalyticsServices: FirebaseAnalyticsService) {
    this.menu_icons = SpriteConstant.MENU_ICONS;
    const mobilePath = '';
    const menuListObject = MenuListConstant.MENULIST;
    this.symbolsArr = menuListObject.historysummary.menuListItems;
  }

  ngOnInit() {
    this.version = PageConstant.VERSION;
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(
    event: KeyboardEvent
  ) {
    this.onCloseClick();
  }

  onCloseClick = (event = null) => {
    this.eventEmit.emit('close');
  };
  onSymbolsClick = (event = null) => {
    let tutorialIndex = 1;
    if (event.tutorialIndex) {
      tutorialIndex = event.tutorialIndex;
    }
    /*this.firebaseAnalyticsServices.sendAction(FirebaseConstant.HISTORY[event.menuListName].eventAction,
      FirebaseConstant.HISTORY[event.menuListName].category,FirebaseConstant.HISTORY[event.menuListName].Label,
      FirebaseConstant.HISTORY[event.menuListName].value);*/

    this.eventEmit.emit('symbols_' + tutorialIndex);
  };
}
